import { FlightsSearchWidget } from '../../widgets/flights-search/flightsSearchWidget';
import { WidgetsDeclaration } from '../../shared/interfaces/widgets-declaration';
import '../../shared/services/i18n';

declare let window: WidgetsDeclaration;
window.flightSearchWidget = FlightsSearchWidget;
